import strings from './strings';
import remoteCall from './network-request';

export {
  strings,
  remoteCall
}



// WEBPACK FOOTER //
// ./src/lib/index.js